/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./common-dialog.vue?vue&type=template&id=9a07a3c6&scoped=true&"
import script from "./common-dialog.vue?vue&type=script&lang=ts&"
export * from "./common-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./common-dialog.vue?vue&type=style&index=0&id=9a07a3c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a07a3c6",
  null
  
)

export default component.exports